var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DEMO_COMMUNICATION_LABEL_IDS, getDemoActivityLabelName } from '@web/lib/demo/data/labels';
import { UNCATEGORIZED_LABEL_NAME } from '@workalizer/shared/config';
import { diffComparisonType } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
var comparisonCountFromDiffString = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    if (pct === 0) {
        return current;
    }
    return Math.round(current / (1 + pct / 100));
};
var teamAverageDiff = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    var teamAvg = pct === 0 ? current : current / (1 + pct / 100);
    var diff = getPercentageDiff(teamAvg, current, {
        comparisonType: diffComparisonType.teamAverage
    });
    var displayTeamAvg = Number.isInteger(teamAvg)
        ? teamAvg
        : Math.round(teamAvg * 10) / 10;
    return __assign(__assign({}, diff), { comparisonValueDisplay: String(displayTeamAvg) });
};
var buildCountMetric = function (count, diffs) { return ({
    count: count,
    userDiff: getPercentageDiff(comparisonCountFromDiffString(count, diffs.user), count),
    orgUnitAvgDiff: teamAverageDiff(count, diffs.team)
}); };
var buildMeetingsMetric = function (count, duration, diffs) { return ({
    count: count,
    duration: duration,
    userDiff: getPercentageDiff(comparisonCountFromDiffString(count, diffs.user), count),
    orgUnitAvgDiff: teamAverageDiff(count, diffs.team)
}); };
var buildLabelMetrics = function (row) { return ({
    documents: buildCountMetric(row.documents.count, row.documents.diffs),
    drive: buildCountMetric(row.drive.count, row.drive.diffs),
    chat: buildCountMetric(row.chat.count, row.chat.diffs),
    meetings: buildMeetingsMetric(row.meetings.count, row.meetings.duration, row.meetings.diffs)
}); };
var communicationByLabelRows = [
    {
        documents: { count: 8, diffs: { user: '+60%', team: '+14%' } },
        drive: { count: 15, diffs: { user: '+50%', team: '+20%' } },
        chat: { count: 8, diffs: { user: '+60%', team: '+15%' } },
        meetings: {
            count: 12,
            duration: '8h 30m',
            diffs: { user: '+40%', team: '+25%' }
        }
    },
    {
        documents: { count: 4, diffs: { user: '-20%', team: '0%' } },
        drive: { count: 8, diffs: { user: '-20%', team: '+10%' } },
        chat: { count: 25, diffs: { user: '+47%', team: '+30%' } },
        meetings: {
            count: 6,
            duration: '4h 15m',
            diffs: { user: '+20%', team: '0%' }
        }
    },
    {
        documents: { count: 2, diffs: { user: '+100%', team: '0%' } },
        drive: { count: 3, diffs: { user: '+50%', team: '0%' } },
        chat: { count: 2, diffs: { user: '0%', team: '+100%' } },
        meetings: {
            count: 8,
            duration: '6h 45m',
            diffs: { user: '+60%', team: '+40%' }
        }
    },
    {
        documents: { count: 3, diffs: { user: '-25%', team: '+50%' } },
        drive: { count: 5, diffs: { user: '-17%', team: '+40%' } },
        chat: { count: 12, diffs: { user: '+50%', team: '+33%' } },
        meetings: {
            count: 4,
            duration: '2h 30m',
            diffs: { user: '+33%', team: '0%' }
        }
    },
    {
        documents: { count: 2, diffs: { user: '+100%', team: '+200%' } },
        drive: { count: 6, diffs: { user: '+33%', team: '+17%' } },
        chat: { count: 4, diffs: { user: '+25%', team: '0%' } },
        meetings: {
            count: 3,
            duration: '1h 45m',
            diffs: { user: '0%', team: '-25%' }
        }
    },
    {
        documents: { count: 2, diffs: { user: '+100%', team: '+200%' } },
        drive: { count: 2, diffs: { user: '+100%', team: '+200%' } },
        chat: { count: 1, diffs: { user: '0%', team: '+100%' } },
        meetings: {
            count: 2,
            duration: '1h 0m',
            diffs: { user: '+100%', team: '0%' }
        }
    },
    {
        documents: { count: 3, diffs: { user: '-25%', team: '+50%' } },
        drive: { count: 5, diffs: { user: '-17%', team: '+40%' } },
        chat: { count: 12, diffs: { user: '+50%', team: '+33%' } },
        meetings: {
            count: 4,
            duration: '2h 30m',
            diffs: { user: '+33%', team: '0%' }
        }
    }
];
var communicationByLabelMetrics = communicationByLabelRows.map(buildLabelMetrics);
export var communicationByLabel = function () {
    var labeledRows = DEMO_COMMUNICATION_LABEL_IDS.map(function (labelId, index) { return (__assign({ labelId: labelId, labelName: getDemoActivityLabelName(labelId) }, communicationByLabelMetrics[index])); });
    return __spreadArray(__spreadArray([], labeledRows, true), [
        __assign({ labelId: null, labelName: UNCATEGORIZED_LABEL_NAME }, communicationByLabelMetrics[labeledRows.length])
    ], false);
};
